import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'
import type { DeepCamelCase } from '@/types/utils'
import { requiredString } from '@/utils/zod'

type APIResponse = z.infer<typeof responseSchema>
type CoursesIdsList = DeepCamelCase<APIResponse>
export type CoursesIdsListItem = CoursesIdsList[number]

const responseSchema = z.array(
  z.object({
    id: requiredString(),
    display_name: requiredString(),
    can_be_deleted: z.boolean()
  })
)

const parseResponse = (response: APIResponse): CoursesIdsList =>
  response.map(item => ({
    id: item.id,
    displayName: item.display_name,
    canBeDeleted: item.can_be_deleted
  }))

type Filters = {
  ids?: string[]
  educationLevelIds?: string[]
  domainIds?: string[]
  preferredRoomIds?: string[]
}

export const useCoursesIds = (filters: Filters = {}) =>
  useQuery({
    queryKey: ['panelCoursesListIds', filters],
    staleTime: 60 * 1000,
    queryFn: async () => {
      const response = await httpService.panel.panelCoursesList({
        page: 1,
        page_size: 'max',
        id: filters.ids,
        education_level_id: filters.educationLevelIds,
        domain_id: filters.domainIds,
        preferred_room_id: filters.preferredRoomIds,
        fetchKeys: {
          id: true,
          display_name: true,
          can_be_deleted: true
        }
      })

      return parseResponse(responseSchema.parse(response.results))
    }
  })
